<script lang="ts">
  import { downloadImages } from "../../services/download";
  import { useFeatureToggle } from "../../services/configCatService";
  import { orgDownload, orgEditMetadata, orgFolder, orgShare } from "@nrk/origo";
  import { isNtbSearchHit } from "../../services/searchHit";
  import { type ImageSource, showEdit } from "../../state/page";
  import { notify } from "../../services/notifications";
  import DeleteImagesButton from "../DeleteImages/DeleteImagesButton.svelte";
  import { searchSelectionService } from "../../state/SelectionService";
  import { createMetadataQuery, getMimirSearchHits } from "../../state/queries/mimir";

  export let itemId: string;
  export let itemSource: ImageSource = "Bildebanken";

  let downloadingFiles = false;

  function shareLink() {
    const url = new URL(window.location.href);
    navigator.clipboard.writeText(url.href);
    notify("Lenke kopiert til utklippstavlen", "success", 3000);
  }

  async function handleDownload() {
    downloadingFiles = true;
    try {
      await downloadImages([itemId]);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      downloadingFiles = false;
    }
  }

  $: searchHits = getMimirSearchHits();
  $: searchHit = $searchHits.find((item) => item.id === itemId);
  $: selectionService = searchSelectionService;

  $: query = createMetadataQuery(itemId, itemSource);
  $: image = $query.isSuccess ? $query.data : undefined;

  const externalPatterns = [/\/images\/ntb\//];
  $: externalImage = externalPatterns.some((re) => re.test(window.location.pathname));
</script>

<div class="action-buttons">
  <button class="org-button org-button--secondary org-button--icon-left" on:click={shareLink}>
    {@html orgShare}
    Del
  </button>
  <button
    class="org-button org-button--secondary org-button--icon-left"
    data-for="add-to-collection-dialog"
    >{@html orgFolder} Legg til i samling
  </button>
  {#if image?.highRes}
    <button
      on:click={handleDownload}
      class="org-button org-button--secondary org-button--icon-left"
      aria-busy={downloadingFiles}
      disabled={downloadingFiles}
      >{@html orgDownload} Last ned
    </button>
  {/if}
  {#if !isNtbSearchHit(image)}
    <button
      class="org-button org-button--icon-left org-button--secondary"
      on:click|preventDefault|stopPropagation={() => {
        selectionService.send({ type: "SELECT_ITEMS", itemIds: [itemId] });
        showEdit([itemId]);
      }}
      disabled={externalImage}
    >
      {@html orgEditMetadata}
      Rediger metadata
    </button>
  {/if}
  <DeleteImagesButton
    extraCss="org-button--secondary"
    selectedItems={searchHit ? [searchHit] : []}
    disabled={itemSource === "Ntb"}
  />
</div>

<style>
  .action-buttons {
    margin-top: var(--org-large);
    margin-bottom: var(--org-medium);
    display: flex;
    flex-wrap: wrap;
    gap: var(--org-small);
  }

  .action-buttons button {
    margin-left: 0;
    margin-right: 0;
  }
</style>
